<template>
  <div class="access-denied">
    <div class="content">
      <div class="icon">🚫</div>
      <h1>访问被拒绝</h1>
      <p>您没有权限访问此页面</p>
      <p class="sub">Access Denied</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied'
}
</script>

<style scoped>
.access-denied {
  min-height: 100vh;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.content {
  text-align: center;
  padding: 40px;
}

.icon {
  font-size: 80px;
  margin-bottom: 20px;
}

h1 {
  font-size: 32px;
  margin-bottom: 15px;
  color: #ff6b6b;
}

p {
  font-size: 18px;
  color: #aaa;
}

.sub {
  font-size: 14px;
  margin-top: 10px;
  color: #666;
}
</style>
